import { Controller } from "@hotwired/stimulus"

// branding-preview — live-updates the brand watermark in the wizard preview as
// the creator edits the branding step (composable kit-template engine, branding
// aspect). Mounted on the branding FORM; the watermark lives in the preview
// (a different subtree, the right rail), so it's reached via document queries
// rather than Stimulus targets. Generic: works in every template's preview
// because they all render the shared Common::BrandingPreviewComponent.
const LOGO_RATIO = 2.0

export default class extends Controller {
  connect() {
    // Reveal the safe-area guide only while editing branding, then sync once.
    const guide = document.querySelector("[data-branding-safearea]")
    if (guide) guide.style.display = "block"
    this.update()
  }

  disconnect() {
    const guide = document.querySelector("[data-branding-safearea]")
    if (guide) guide.style.display = "none"
  }

  update() {
    const f = this.fields()
    const wm = document.querySelector("[data-branding-watermark]")
    if (!wm) return
    const nameEl = document.querySelector("[data-branding-name]")
    const logoEl = document.querySelector("[data-branding-logo]")

    const name = (f.name || "").trim()
    const logo = (f.logo_url || "").trim()
    const active = f.show_branding && (name || logo)
    const size = parseFloat(f.size) || 3.5

    wm.style.display = active ? "flex" : "none"
    wm.style.left = `${f.x ?? 82}%`
    wm.style.top = `${f.y ?? 84}%`
    wm.style.opacity = `${(f.opacity ?? 90) / 100}`
    wm.style.gap = `${size * 0.3}cqw`

    if (nameEl) {
      nameEl.textContent = name
      nameEl.style.display = name ? "" : "none"
      nameEl.style.fontSize = `${size}cqw`
      nameEl.style.color = f.primary_color || "#FFFFFF"
    }
    if (logoEl) {
      logoEl.style.display = logo ? "block" : "none"
      logoEl.style.height = `${size * LOGO_RATIO}cqw`
      if (logo && logoEl.getAttribute("src") !== logo) logoEl.src = logo
    }

    this.element.querySelectorAll("[data-branding-readout]").forEach((el) => {
      const v = f[el.dataset.brandingReadout]
      if (v != null) el.textContent = `${v}%`
    })
  }

  // Collect the branding form values keyed by data-branding-field.
  fields() {
    const out = {}
    this.element.querySelectorAll("[data-branding-field]").forEach((el) => {
      out[el.dataset.brandingField] = el.type === "checkbox" ? el.checked : el.value
    })
    return out
  }
}
